<script lang="ts">
	import type { Snippet } from "svelte"

	interface Props {
		heading?: string
		children: Snippet
	}

	let { heading, children }: Props = $props()
</script>

<div class="projector-section">
	{#if heading}
		<h2 class="setting-heading">{heading}</h2>
	{/if}
	{@render children()}
</div>

<style>
</style>
